/**
 * Convert studio bookmark payloads into playlist track entries.
 */
import { bookmarkEntryKey } from './studioBookmarks';

export function playlistTrackKey(track) {
  if (track?.kind && track?.sourceId) return `${track.kind}:${track.sourceId}`;
  return track?.id || '';
}

export function trackFromBookmark(bookmark) {
  if (!bookmark?.kind || bookmark.id == null) return null;
  const payload = bookmark.payload || {};
  let title = bookmark.title || 'Untitled';
  let artist = bookmark.subtitle || '';
  let url = '';
  let genre = '';
  let duration = '';

  switch (bookmark.kind) {
    case 'radio':
      url = payload.station?.url || '';
      artist = [payload.station?.country, payload.station?.tags?.split(',')[0]]
        .filter(Boolean)
        .join(' · ');
      genre = 'Radio';
      break;
    case 'collection':
      url = payload.url || '';
      artist = payload.artist || artist;
      genre = payload.album || '';
      break;
    case 'musician-work':
      url = payload.url || '';
      artist = payload.artist || artist;
      genre = payload.album || '';
      break;
    case 'player-recording':
      url = payload.url || '';
      artist = payload.artist || artist;
      break;
    case 'playlist-track':
      title = payload.title || title;
      artist = payload.artist || artist;
      genre = payload.genre || '';
      duration = payload.duration || '';
      break;
    case 'playlist-seed':
      title = payload.title || title;
      artist = payload.artist || artist;
      genre = payload.genre || '';
      duration = payload.duration || '';
      break;
    case 'resource':
      genre = [payload.category, payload.region].filter(Boolean).join(' · ');
      break;
    default:
      break;
  }

  return {
    title: String(title).trim() || 'Untitled',
    artist: String(artist).trim(),
    url: String(url).trim(),
    genre: String(genre).trim(),
    duration: String(duration).trim(),
    kind: bookmark.kind,
    sourceId: String(bookmark.id),
    payload,
    entryKey: bookmarkEntryKey(bookmark),
  };
}

export function isTrackInPlaylist(playlist, trackMeta) {
  if (!playlist?.tracks?.length || !trackMeta) return false;
  const key = trackMeta.entryKey || playlistTrackKey(trackMeta);
  return playlist.tracks.some((t) => {
    if (trackMeta.entryKey && t.kind && t.sourceId) {
      return `${t.kind}:${t.sourceId}` === trackMeta.entryKey;
    }
    return playlistTrackKey(t) === key;
  });
}
